import { z } from "zod";

import { commentSchema } from "./comment";
import { userSchema } from "./user";

const fileSchema = z.object({
  id: z.number(),
  mime_type: z.string(),
  original_name: z.string(),
  file_url: z.url(),
  file_type: z.string(),
  file_size: z.number(),
  type: z.number(),
  has_metadata: z.boolean().optional(),
  created_at: z.iso.datetime({ offset: true }),
  updated_at: z.iso.datetime({ offset: true }).nullable(),
  ocrolus_status: z.string().nullable().optional(),
  comments: z.array(commentSchema).optional(),
  owner: userSchema,
  updated_by: userSchema,
});

/**
 * A file uploaded to the Lendflow system.
 */
export type LfFile = z.infer<typeof fileSchema>;

export { fileSchema };
